import React, { Fragment } from "react";
import { UISref } from "@uirouter/react";
import i18n from "i18next";

import { Panel, PanelHeader } from "../Layout/Panel";
import { hasUserAtLeastOneRole } from "../../helpers/Authorization/authorizationHelpers";

const NoRoles = () => {
  const hasAtLeastOneRole = hasUserAtLeastOneRole();
  return (
    <Panel className="error">
      <PanelHeader title="" id={i18n.t("error.noRoles.title")} />
      <div className="error__container --centered">
        <span className="error__label">{i18n.t("error.noRoles.firstLabel")}</span>
        <span className="error__label">{i18n.t("error.noRoles.secondLabel")}</span>
        {hasAtLeastOneRole && (
          <Fragment>
            <span className="error__text">{i18n.t("error.noRoles.text")}</span>
            <UISref to="home">
              <a className="error__button">{i18n.t("error.noRoles.button")}</a>
            </UISref>
          </Fragment>
        )}
      </div>
    </Panel>
  );
};

export default NoRoles;



// WEBPACK FOOTER //
// ./src/components/Errors/NoRoles.js